import { jwtDecode } from 'jwt-decode';

interface TokenPayload {
    exp: number;
    [key: string]: any;
}

function getCookie(name: string): string | null {
    if (typeof document === 'undefined') return null;

    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) {
        return parts.pop()?.split(';').shift() || null;
    }

    return null;
}

export const authStorage = {
    setTokens: (accessToken: string, refreshToken: string): void => {
        if (typeof document === 'undefined') return;

        document.cookie = `accessToken=${accessToken}; path=/;`;
        document.cookie = `refreshToken=${refreshToken}; path=/;`;
    },

    clearTokens: (): void => {
        if (typeof document === 'undefined') return;

        document.cookie = 'accessToken=; path=/;';
        document.cookie = 'refreshToken=; path=/;';
    },

    getAccessToken: (): string | null => {
        return getCookie('accessToken');
    },

    getRefreshToken: (): string | null => {
        return getCookie('refreshToken');
    },

    isTokenValid: (token: string | null): boolean => {
        if (!token) return false;

        try {
            const decoded = jwtDecode<TokenPayload>(token);
            const currentTime = Date.now() / 1000;
            return decoded.exp > currentTime + 10;
        } catch {
            return false;
        }
    },

    getValidAccessToken: (): string | null => {
        const token = authStorage.getAccessToken();
        return authStorage.isTokenValid(token) ? token : null;
    },

    getValidRefreshToken: (): string | null => {
        const token = authStorage.getRefreshToken();
        return authStorage.isTokenValid(token) ? token : null;
    },

    hasValidTokens: (): boolean => {
        const accessToken = authStorage.getAccessToken();
        const refreshToken = authStorage.getRefreshToken();

        if (authStorage.isTokenValid(accessToken)) {
            return true;
        }

        return authStorage.isTokenValid(refreshToken);
    },
};
